
import React from "react";
import { useAuth } from "@/context/AuthContext";

interface SubscriptionDebugInfoProps {
  showHeading: boolean;
  supabaseStatus: string;
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  subscriptions?: any[];
}

export function SubscriptionDebugInfo({
  showHeading,
  supabaseStatus,
  isLoading,
  isError,
  error,
  subscriptions
}: SubscriptionDebugInfoProps) {
  const { user, isAdmin } = useAuth();
  
  // Hide debug info completely if not admin
  if (!isAdmin) {
    return null;
  }

  return (
    <div className="mb-4 bg-gray-50 p-3 rounded border">
      <p className="text-sm text-gray-500">Debug: Component rendered, showHeading = {String(showHeading)}</p>
      <p className="text-sm text-gray-500">Debug: Supabase status: {supabaseStatus}</p>
      <p className="text-sm text-gray-500">
        Debug: Data status: {isLoading ? "Loading..." : isError ? "Error" : subscriptions ? `Loaded ${subscriptions.length} subscriptions` : "No data"}
      </p>
      {isError && (
        <p className="text-sm text-red-500">Error details: {error instanceof Error ? error.message : String(error)}</p>
      )}
    </div>
  );
}
